import { getAuthenticatedAxios } from "../../hooks/authentication";
import type { CollectionClient } from "./collection-client.types";
import {
  createHttpCollectionClient,
  getCxApplicationApiUrl,
} from "./http-collection-client";

export * from "./collection-client.types";
export {
  CX_APPLICATION_API_URLS,
  LOUNGE_COLLECTIONS_URL,
} from "./collections.constants";
export {
  createHttpCollectionClient,
  getCxApplicationApiUrl,
  getHttpStatus,
} from "./http-collection-client";
export {
  createMockCollectionClient,
  MOCK_COLLECTIONS,
  MOCK_PROJECTS,
} from "./mock-collection-client";
export {
  createSavedStateStore,
  getSavedStateStore,
  type SavedStateStore,
} from "./saved-state-store";

/**
 * The app-wide client: `cx-srv-application` over the shared authenticated
 * axios (CX-3786), which attaches the CDC token. Tests and stories inject the
 * mock through `CollectionClientContext` instead.
 */
export const collectionClient: CollectionClient = createHttpCollectionClient({
  baseUrl: getCxApplicationApiUrl(window.location.hostname),
  getAxios: () => getAuthenticatedAxios().axios,
});
